import { copy } from "../helpers/copy";
import { notification } from "../helpers/notification";

$(document).ready(function () {
    $('.js-handlebar-item').on('click', function () {
        copy($(this).text());
        notification('success', 'Tag Copied To The Clipboard!')
    });
});
